<template>
	<div class="faq">
		<div class="side">
			<ul class="side__groups">
				<li
					class="side__group"
					v-for="group in faqGroups"
					:key="`side-${group.name}`"
				>
					<a
						:href="`#${group.name.toLowerCase().replace(' ', '_')}`"
						@click.prevent="
							goto(`#${group.name.toLowerCase().replace(' ', '_')}`)
						"
					>
						{{ group.name }}
					</a>
				</li>
			</ul>
		</div>

		<!-- <h2 v-for="(_, group) in faqItems" :key="`h-${group}`">
      <a :href="`#${group.name.toLowerCase().replace(' ', '_')}`">{{ group }}</a>
    </h2> -->
		<div class="main">
			<div class="main__group" v-for="group in faqGroups" :key="group.name">
				<h3
					class="main__group__name"
					:id="group.name.toLowerCase().replace(' ', '_')"
				>
					{{ group.name }}
				</h3>
				<ul class="main__group__list">
					<li
						v-for="(item, j) in group.items"
						:key="j"
						class="main__group__list-item"
					>
						<div class="icon">
							<div v-show="selectedId === item.id">
								<i class="fal fa-minus" />
							</div>
							<div v-show="selectedId !== item.id">
								<i class="fal fa-plus" />
							</div>
						</div>
						<smooth-reflow>
							<h6
								class="main__group__question"
								:class="{
									'main__group__question--active': selectedId === item.id
								}"
								@click="selectedId = selectedId !== item.id ? item.id : null"
							>
								{{ item.question }}
							</h6>
							<div
								class="main__group__answer"
								v-if="selectedId === item.id"
								v-html="item.answer"
							></div>
						</smooth-reflow>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import SmoothReflow from "./smooth-reflow.vue";

export default {
	components: { SmoothReflow },
	name: "FAQ",
	selector: "#vue-faq",
	props: {
		faqItemsRaw: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			selectedId: null
		};
	},
	computed: {
		faqGroups() {
			const reducedGroups = this.faqItemsRaw.reduce((groups, item) => {
				const { group, ...rest } = item;
				return {
					...groups,
					[group]: [...(groups[group] || []), rest]
				};
			}, {});

			return Object.entries(reducedGroups).map(([group, items], i) => ({
				name: group,
				items: items.map((item, j) => ({ ...item, id: `${i}-${j}` }))
			}));
		}
	},
	methods: {
		goto(id) {
			const el = document.querySelector(id);
			if (!el) return;
			const offsetTop = el.offsetTop;
			window.scrollToPosition(offsetTop - 80);
		}
	}
};
</script>

<style lang="scss" scoped>
.faq {
	@include inner-container();
	margin-top: 64px;
	display: flex;
	justify-content: space-between;
}

.side {
	flex: 1;

	&__groups {
		margin: 0;
		padding: 0;
		list-style: none;
		position: sticky;
		top: 120px;
	}

	&__group {
		& + & {
			margin-top: 16px;
		}
		a {
			color: $black;
			text-decoration: none;
			font-size: 16px;
		}
	}
}

.main {
	flex: 2;

	&__group {
		& + & {
			margin-top: 64px;
		}

		&__name {
			margin: 0;
			font-size: 16px;
			line-height: 24px;
		}

		&__list {
			margin: 0;
			margin-top: 32px;
			padding: 0;
			list-style: none;
			&-item {
				display: flex;
				& + & {
					margin-top: 24px;
				}
			}
		}

		&__question {
			margin: 0;
			font-size: 21px;
			line-height: 24px;
			font-weight: 400;
			transition: color 0.15s ease-out;
			font-weight: 200;

			&--active {
				color: $teal;
			}
		}

		&__answer {
			margin: 0;
			margin-top: 16px;
			font-size: 16px;
			line-height: 24px;
			font-weight: 200;
		}
	}
}

.icon {
	margin-right: 32px;
}
</style>